<template>
  <div :style="wrapStyle">
      <!--     H5  -->
    <popup-address-dialog-h5
      ref="popupddress-dialog-h5"
      v-if="deviceMode=== 'h5' || deviceMode === 'h5-h'"
      :configurationData="configurationData"
      :styles="styles"
      :events="events"
      v-bind="$props"
    />
    <!--     pc版  -->
    <popup-address-dialog-pc
      v-if="deviceMode=== 'pc'"
      :configurationData="configurationData"
      :styles="styles"
      :events="events"
      v-bind="$props"
    />
    </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
// import { componentBaseMixin } from '../../../../ceiba-base-components';
import PopupAddressDialogH5 from './popup-address-dialog-h5.vue';
import PopupAddressDialogPc from './popup-address-dialog-pc.vue';

export default {
  name: 'CPopupAddress',
  components: {
    PopupAddressDialogH5,
    PopupAddressDialogPc,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      isMobile: null,
    };
  },
  computed: {
    wrapStyle() {
      return {
        top: this.styles.base.top,
        left: this.styles.base.left,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    computedStyle() {
      return {
        backgroundImage: this.configurationData.btnImage
          ? `url(${this.configurationData.btnImage})`
          : 'none',
      };
    },
  },
  async mounted() {
    console.log(`type-${this.deviceMode}`);
    // alert(this.deviceMode);
    await this.initialize();
  },
  methods: {
    async initialize() {
    },
  },
};
</script>
<style lang="scss">
// @import './styles.scss';
</style>
